import { Box } from "@mantine/core";
import { useSessionStore } from "../stores/UserStore";
import LogoMini from "./LogoMini";
import LogoHorizontal from "./LogoHorizontal";

export function Logo({ isLoader, ...props }) {
  const reseller = useSessionStore((s) => s.reseller);

  if (reseller?.name === "Magileads") {
    if (isLoader) {
      return (
        <Box {...props}>
          <LogoMini />
        </Box>
      );
    }
    return (
      <Box {...props}>
        <LogoHorizontal />
      </Box>
    );
  }

  return (
    <Box {...props}>
      {isLoader ? (
        <img
          src={reseller?.logo_menu_url}
          alt="logo"
          className="logo"
          width={"100%"}
          style={{ objectFit: "contain" }}
        />
      ) : (
        <img
          src={props.sm ? reseller?.logo_menu_url : reseller?.logo_url}
          alt="logo"
          className="logo"
          height={"100%"}
          width={"100%"}
          style={{ objectFit: "contain" }}
        />
      )}
    </Box>
  );
}
